import { OPTION_DETAIL_SEPARATOR } from './filters';

interface PersonIdentity {
  hrEmpId: string | null | undefined;
  mobile: string | null | undefined;
}

export function getPersonOptionDetail({ hrEmpId, mobile }: PersonIdentity): string {
  return [hrEmpId, mobile].filter(Boolean).join(OPTION_DETAIL_SEPARATOR);
}
